export const PlateItemsColumns = () => {
  const loggedInUser = JSON.parse(sessionStorage.getItem("userData"));
  const isSystemUser = [1, 2, 3].includes(loggedInUser?.role_value);

  return [
    {
      title: "No",
      dataIndex: "PlateNo",
      key: "PlateNo",
      hidden: !isSystemUser,
    },
    {
      title: "Name",
      dataIndex: "PlateName",
      key: "PlateName",
    },
    {
      title: "Description",
      dataIndex: "PlateDesc",
      key: "PlateDesc",
    },
    {
      title: "Code",
      dataIndex: "PlateCode",
      key: "PlateCode",
    },
    {
      title: "OEM",
      dataIndex: "OemName",
      key: "OemName",
    },
    {
      title: "Dealer",
      dataIndex: "DealerName",
      key: "DealerName",
    },
    {
      title: "Device Name",
      dataIndex: "DeviceName",
      key: "DeviceName",
    },
    {
      title: "Access Item Name",
      dataIndex: "ItemName",
      key: "ItemName",
    },
  ];
};
